import { useCallback } from "react";
import type { StudentQuestionAnswer, StudentTestExercise } from "p6m-p6u";
import UnderlinedInput from "../../../basic/underlinedInput/UnderlinedInput";
import ExerciseWrapper from "./ExerciseWrapper";
import { getExerciseProgress } from "../../../helpers/OnlineTestHelper";

interface FreeTextExerciseProps {
    exercise: StudentTestExercise;
    exerciseIndex: number;
    studentAnswer: StudentQuestionAnswer;
    onAnswerUpdate: (updatedAnswer: StudentQuestionAnswer, exerciseId: string) => void;
}

const FreeTextExercise = (props: FreeTextExerciseProps) => {
    const exerciseId = props.exercise.id;
    const studentAnswer = props.studentAnswer;
    const onAnswerUpdate = props.onAnswerUpdate;

    const progress = getExerciseProgress(studentAnswer, props.exercise.questionMode);

    const handleTextChange = useCallback(
        (value: string) => {
            if (!exerciseId) return;
            onAnswerUpdate({ ...studentAnswer, textAnswer: value }, exerciseId);
        },
        [exerciseId, studentAnswer, onAnswerUpdate]
    );

    if (!exerciseId) return null;

    return (
        <ExerciseWrapper
            data-testid="online-test-exercise-free-text"
            number={props.exerciseIndex + 1}
            title={props.exercise.extraComments ?? ""}
            progress={progress}
        >
            <div className="flex flex-col gap-xs">
                {props.exercise.textFieldStarterText && (
                    <p className="text-l text-p6-grey-dark italic px-xs">{props.exercise.textFieldStarterText}</p>
                )}
                <UnderlinedInput
                    data-testid="online-test-free-text-input"
                    text={studentAnswer.textAnswer ?? ""}
                    setText={handleTextChange}
                    initialLines={5}
                />
            </div>
        </ExerciseWrapper>
    );
};

export default FreeTextExercise;
